<template>
  <div class="navigation">
    <!--Tema Dark - BEE-->
    <!--  TODO: Retornar valor default  -->
    <nav :class="configs.data.partner.owner === 1 ? 'navbar-dark bg-dark' : 'navbar-light bg-white'"
      class="navbar navbar-expand-md fixed-top static-top top_navbar shadow-sm">
      <!--Tema Light - PARTNER-->
      <!--<nav :class="configs.dark_mode ? 'navbar-light_dark' : ''" class="navbar navbar-expand-md fixed-top static-top top_navbar shadow-sm">-->
      <router-link :to="{ name: 'Home' }">
        <div class="logo d-flex" :class="($mq === 'mobile' || $mq === 'tablet') ? 'pr-0' : 'pr-5'">
          <!--  TODO: Retornar valor default  -->
          <img class="logo_brand" :style="configs.data.partner.owner === 1 ? 'height: 30px; margin-top: -6px;' : ''"
            :src="configs.data.partner.owner === 1 ? logo_beecrm_white_blue : configs.data.partner.image">

          <div v-if="false && configs.data.partner.owner === 1" class="text-white-50 d-flex"
            :style="($mq === 'mobile' || $mq === 'tablet') ? 'font-size: 12px; padding-top: 11px;' : 'font-size: 18px; padding-top: 6px;'">
            <div class="pl-3 px-2">|</div>
            <div>CRM</div>
          </div>
        </div>
      </router-link>
      <!--Menu mobile-->
      <div class="d-flex hidden-md">
        <span class="d-flex align-items-center pr-0 ml-0" style="color:#aeaeae;">
          <!--Notifications-->
          <div class="nav-item dropdown no-arrow">
            <a class="d-flex pr-2 align-items-center nav-link dropdown-toggle" id="langDropdown2" role="button"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span>
                <img style="margin-top: .2rem; font-size: 1.2rem; margin-bottom: 2px; width: 25px; height: 20px" :src="me.data.language_key === 0 ? flag_br :
                  me.data.language_key === 1 ? flag_us :
                    flag_es" alt="">
              </span>
            </a>
            <!-- Dropdown - User Information -->
            <div class="dropdown-menu dropdown-menu_navbar dropdown-menu-right shadow-sm animated--grow-in"
              aria-labelledby="langDropdown2" style="margin: .9rem 0 0;">
              <div v-for="(lang, index) in configs.data.user_languages" :key="lang.id">
                <span @click.prevent="setLanguage(lang.id)" class="cursor_pointer dropdown-item">
                  <img style="margin-top: .2rem; font-size: 1.2rem; margin-bottom: 2px; width: 25px; height: 20px" :src="lang.id === 0 ? flag_br :
                    lang.id === 1 ? flag_us :
                      flag_es" alt="">
                  <span class="pl-2">{{ lang.description }}</span>
                </span>
                <div class="dropdown-divider"></div>
              </div>
            </div>
          </div>
          <div class="nav-item dropdown no-arrow">
            <a class="d-flex align-items-center nav-link dropdown-toggle pr-1" id="notifyDropdown2" role="button"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <div class="d-flex">
                <div>
                  <i style="margin-top: .2rem; font-size: 1.5rem; font-weight: 500;"
                    :class="notifications.count > 0 ? 'bx-tada' : ''" class="bx bxs-bell"></i>
                </div>
                <div v-if="notifications.count > 0">
                  <span style="margin-left: -5px" class="badge pulse-danger badge-danger">
                    {{ notifications.count }}
                  </span>
                </div>
              </div>
            </a>
            <!-- Dropdown - Notifications -->
            <NotificationsDropdown id_dropdown="notifyDropdown2" position="dropdown-menu-right" :data="notifications"
              :method="deleteAllNotifications" pagination_commit="SET_NOTIFICATIONS" />
          </div>
          <div @click.prevent="configs.menu_mobile = true" class="nav-link pr-0">
            <span>
              <i style="margin-top: .2rem; font-size: 1.7rem;" class="bx bx-menu"></i>
            </span>
          </div>
        </span>
      </div>

      <div class="collapse navbar-collapse" id="navbarCollapse">
        <!--Menu list-->
        <ul class="navbar-nav mr-auto">
          <!--Dashboard-->
          <li class="nav-item ml-1 mr-4" :class="{ 'active': $route.name === 'Home' }">
            <router-link :to="{ name: 'Home' }" class="nav-link middle">
              <!--              <i style="font-size: 1.4rem; margin-right: .7rem" class="bx bx-tachometer"></i>-->
              <span style="font-size: 1rem;">{{ getTranslations('expression_52') }}</span>
            </router-link>
          </li>

          <!-- Kanban Link -->
          <li class="nav-item ml-1 mr-4" :class="{ 'active': $route.name === 'Kanban' }">
            <router-link :to="{ name: 'Kanban' }" class="nav-link middle">
              <span style="font-size: 1rem;">Quadro</span>
            </router-link>
          </li>

          <!-- Gallery Link -->
          <li class="nav-item ml-1 mr-4" :class="{ 'active': $route.name === 'Gallery' }">
            <router-link :to="{ name: 'Gallery' }" class="nav-link middle">
              <span style="font-size: 1rem;">Galeria</span>
            </router-link>
          </li>


          <!--ATIVIDADES-->
          <li class="nav-item ml-1 mr-4" :class="{ 'active': $route.name === 'Activities' || $route.name === 'Activity' }">
            <router-link :to="{ name: 'Activities' }" class="nav-link middle">
              <!--              <i style="font-size: 1.4rem; margin-right: .7rem" class="bx bx-group"></i>-->
                <span style="font-size: 1rem;">{{ getTranslations('expression_69') }}</span>
            </router-link>
          </li>

          <!--Leads-->
          <li class="nav-item ml-1 mr-4" :class="{ 'active': $route.name === 'Leads' || $route.name === 'Lead' }">
            <router-link :to="{ name: 'Leads' }" class="nav-link middle">
              <!--              <i style="font-size: 1.4rem; margin-right: .7rem" class="bx bx-user-plus"></i>-->
              <span style="font-size: 1rem;">{{ getTranslations('expression_35') }}</span>
            </router-link>
          </li>


          <!--Campanhas-->
          <li
            v-if="(isTester() && me.data.role_key > 0) || (me.data.role_key > 0 && getCampaignsChannelsAvailableArray().length > 0)"
            class="nav-item ml-1 mr-4" :class="{ 'active': $route.name === 'Campaigns' || $route.name === 'Campaign' }">
            <router-link :to="{ name: 'Campaigns' }" class="nav-link middle">
              <!--              <i style="font-size: 1.4rem; margin-right: .7rem" class="bx bx-rocket"></i>-->
              <span class="d-flex" style="font-size: 1rem;">{{ getTranslations('expression_3') }}
                <div v-if="false && isTester" class="pl-2 pt-0" style="margin-top: 0; font-size: .9rem;">
                  <span class="badge badge-danger rounded-0 font-weight-bold">Premium</span>
                </div>
              </span>
            </router-link>
          </li>

          <!--Relatórios-->
          <li class="nav-item ml-1 mr-3 dropdown arrow">
            <a :class="{
              'active': $route.name === 'ReportsTickets' ||
                $route.name === 'ReportsCampaigns' ||
                $route.name === 'ReportsOperatorsLeads' ||
                $route.name === 'ReportsSources' ||
                $route.name === 'ReportsEmail' ||
                $route.name === 'ReportsHsm' ||
                $route.name === 'ReportsSms' ||
                $route.name === 'ReportsVoip'
            }" class="nav-link dropdown-toggle"
              id="ReportsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span class="mr-2" style="font-size: 1rem;">{{ getTranslations('expression_59') }}</span>
            </a>
            <!-- Dropdown - Reports -->
            <div class="dropdown-menu mt-3 dropdown-menu_navbar dropdown-menu-left shadow-sm animated--grow-in"
              aria-labelledby="ReportsDropdown">
              <div v-if="me.data.role_key > 0">

                <div class="dropdown-divider"></div>

                <!--Engajamento-->
                <router-link :to="{ name: 'ReportsCampaigns' }" class="dropdown-item">
                  <i class="fas fa-thumbs-up fa-sm fa-fw mr-2 text-gray-400"></i>
                  {{ getTranslations('expression_16') }}
                </router-link>

                <!--HIDDEN TEMP-->
                <div v-if="true" class="dropdown-divider"></div>
                <!--E-mail-->
                <router-link v-if="true" :to="{ name: 'ReportsEmail' }" class="dropdown-item">
                  <i class="bx bxs-envelope-open fa-sm fa-fw mr-2 text-gray-400"></i>
                  E-mail
                  <!-- {{ getTranslations('expression_53') }}-->
                </router-link>
                <div v-if="true" class="dropdown-divider"></div>
                <!--HSM-->
                <router-link v-if="true" :to="{ name: 'ReportsHsm' }" class="dropdown-item">
                  <i class="bx bx-copy-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                  HSM
                  <!-- {{ getTranslations('expression_53') }}-->
                </router-link>
                <div v-if="true" class="dropdown-divider"></div>
                <!--NPS-->
                <router-link v-if="true" :to="{ name: 'ReportsNps' }" class="dropdown-item">
                  <i class="bx bxs-star fa-sm fa-fw mr-2 text-gray-400"></i>
                  NPS
                  <!-- {{ getTranslations('expression_53') }}-->
                </router-link>
                <!--HIDDEN TEMP-->

                <div class="dropdown-divider"></div>
                <!--Performance-->
                <div class="dropdown-divider"></div>
                <router-link :to="{ name: 'ReportsOperatorsLeads' }" class="dropdown-item">
                  <i class="fas fa-headset fa-sm fa-fw mr-2 text-gray-400"></i>
                  {{ getTranslations('expression_53') }}
                </router-link>

                <!--HIDDEN TEMP-->
                <div v-if="true" class="dropdown-divider"></div>
                <!--SMS-->
                <router-link v-if="true" :to="{ name: 'ReportsSms' }" class="dropdown-item">
                  <i class="bx bxs-message fa-sm fa-fw mr-2 text-gray-400"></i>
                  <!-- {{ getTranslations('expression_53') }}-->
                  SMS
                </router-link>
                <div v-if="true" class="dropdown-divider"></div>
                <!--VOIP-->
                <router-link v-if="true" :to="{ name: 'ReportsVoip' }" class="dropdown-item">
                  <i class="bx bxs-phone-call fa-sm fa-fw mr-2 text-gray-400"></i>
                  VOIP
                  <!-- {{ getTranslations('expression_53') }}-->
                </router-link>
                <div class="dropdown-divider"></div>
              </div>
              <!--Protocolos-->
              <router-link :to="{ name: 'ReportsTickets' }" class="dropdown-item">
                <i class="fas fa-comments fa-sm fa-fw mr-2 text-gray-400"></i>
                {{ getTranslations('expression_73') }}
              </router-link>
              <div class="dropdown-divider" v-if="me.data.role_key > 0"></div>
              <!--Logs webhooks-->
              <router-link v-if="me.data.role_key > 0" :to="{ name: 'ReportsWebhooks' }" class="dropdown-item">
                <i class="bx bxs-error-circle fa-sm fa-fw mr-2 text-gray-400"></i>
                {{ getTranslations('expression_1211') }}
              </router-link>
              <!--Chat-bot-->
              <router-link v-if="me.data.role_key > 0" :to="{ name: 'ReportsChatbot' }" class="dropdown-item">
                <i class="bx bx-bot fa-sm fa-fw mr-2 text-gray-400"></i>
                {{ getTranslations('expression_246') }}
              </router-link>
            </div>
          </li>
          <li v-if="me.data.role_key > 0" class="nav-item ml-1 mr-3 dropdown arrow">
            <a :class="{
              'active': $route.name === 'Channels' ||
                $route.name === 'Channel' ||
                $route.name === 'Users'
            }" class="nav-link dropdown-toggle" id="ConfigsDropdown"
              role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span class="mr-2" style="font-size: 1rem;">{{ getTranslations('expression_62') }}</span>
            </a>
            <!-- Dropdown - Configurations -->
            <div class="dropdown-menu mt-3 dropdown-menu_navbar dropdown-menu-left shadow-sm animated--grow-in"
              aria-labelledby="ConfigsDropdown">
              <div class="dropdown-divider"></div>
              <router-link :to="{ name: 'Channels' }" class="dropdown-item">
                <i class="fas fa-mobile-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                {{ getTranslations('expression_4') }}
              </router-link>
              <div class="dropdown-divider"></div>
              <router-link :to="{ name: 'Users' }" class="dropdown-item">
                <i class="fas fa-user-friends fa-sm fa-fw mr-2 text-gray-400"></i>
                {{ getTranslations('expression_82') }}
              </router-link>
            </div>
          </li>
        </ul>
        <!--Menu icons-->
        <ul class="navbar-nav mr-auto" style="display: contents;">
          <!--Select channel-->
          <li v-if="false" class="nav-item dropdown no-arrow">
            <a class="d-flex align-items-center nav-link dropdown-toggle pr-4" id="channelDropdown" role="button"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <div class="d-flex">
                <div>
                  <i style="margin-top: .2rem; font-size: 1.5rem; font-weight: 500;" class="bx bxs-mobile-vibration"></i>
                </div>
              </div>
            </a>
            <!-- Dropdown - Notifications -->
            <div class="dropdown-menu dropdown-menu_navbar dropdown-menu-right shadow-sm animated--grow-in"
              aria-labelledby="channelDropdown">
              <div class="col-12 px-4">
                <label class="mb-1">{{ getTranslations('expression_6') }} </label>
                <div class="input-group pt-1 mb-2">
                  <select class="input_forms custom-select pl-50" id="addlead_chat_channel" style="min-width: 200px;">
                    <option :value="null">{{ getTranslations('expression_123') }}</option>
                    <option v-for="channel in channels.data" :key="channel.id" :value="channel.id">{{
                      channel.name
                    }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </li>
          <!--Dark mode-->
          <li v-if="false" class="nav-item dropdown no-arrow">
            <div @click.prevent="configs.dark_mode = !configs.dark_mode" v-b-tooltip.bottom title="Modo Dark"
              class="d-flex align-items-center nav-link cursor-pointer pl-3 pr-3">
              <div class="d-flex">
                <div>
                  <i style="margin-top: 0; font-size: 27px; font-weight: 500;" class="bx bx-brightness-half"></i>
                </div>
              </div>
            </div>
          </li>
          <!--Lang Dropdown-->
          <li class="nav-item dropdown no-arrow">
            <div class="d-flex pr-3 align-items-center nav-link dropdown-toggle" id="langDropdown" role="button"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <img style="margin-top: .2rem; font-size: 1.2rem; margin-bottom: 2px; width: 25px; height: 20px" :src="me.data.language_key === 0 ? flag_br :
                me.data.language_key === 1 ? flag_us :
                  flag_es" alt="">
            </div>
            <!-- Dropdown - User Information -->
            <div class="dropdown-menu dropdown-menu_navbar dropdown-menu-right shadow-sm animated--grow-in"
              aria-labelledby="langDropdown" style="margin: 1rem 0 0;">
              <div class="dropdown-divider"></div>
              <div v-for="(lang, index) in configs.data.user_languages" :key="lang.id">
                <span @click.prevent="setLanguage(lang.id)" class="cursor_pointer dropdown-item">
                  <img style="margin-top: .2rem; font-size: 1.2rem; margin-bottom: 2px; width: 25px; height: 20px" :src="lang.id === 0 ? flag_br :
                    lang.id === 1 ? flag_us :
                      flag_es" alt="">
                  <span class="pl-2">{{ lang.description }}</span>
                </span>
                <div class="dropdown-divider"></div>
              </div>
            </div>
          </li>
          <!--Chat-->
          <!-- me.data.role_key === 0 -->
          <li v-if="[0,1].includes(me.data.role_key) && getOperatorsArray('user_id', me.data.id).length > 0"
            class="nav-item dropdown no-arrow">
            <router-link :to="{ name: 'Chat' }" :class="{ 'active': $route.name === 'Chat' }" v-b-tooltip.bottom
              :title="getTranslations('expression_312')" class="d-flex align-items-center nav-link cursor-pointer pr-3">
              <div class="d-flex">
                <div>
                  <i style=" margin-top: .2rem; font-size: 1.5rem; font-weight: 500;" class="bx bxs-chat"></i>
                </div>
              </div>
            </router-link>
          </li>
          <!--Notifications-->
          <li class="nav-item dropdown no-arrow">
            <a class="d-flex align-items-center nav-link dropdown-toggle pr-2" id="notifyDropdown" role="button"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <div class="d-flex">
                <div>
                  <i style="color:green;margin-top: .2rem; font-size: 1.5rem; font-weight: 500;"
                    :class="notifications.count > 0 ? 'bx-tada' : ''" class="bx bxs-bell"></i>
                </div>
                <div v-if="notifications.count > 0">
                  <span style="margin-left: -5px" class="badge pulse-danger badge-danger">
                    {{ notifications.count }}
                  </span>
                </div>
              </div>
            </a>
            <!-- Dropdown - Notifications -->
            <NotificationsDropdown id_dropdown="notifyDropdown" position="dropdown-menu-right" :data="notifications"
              :method="deleteAllNotifications" pagination_commit="SET_NOTIFICATIONS" />
          </li>
          <!--User links-->
          <li class="nav-item dropdown no-arrow">
            <a class="d-flex align-items-center pl-3 nav-link dropdown-toggle" id="userDropdown" role="button"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span>
                <i style="color:blue;margin-top: .2rem; font-size: 1.5rem; font-weight: 500;" class="bx bxs-user"></i>
              </span>
            </a>
            <!-- Dropdown - User Information -->
            <div class="dropdown-menu dropdown-menu_navbar dropdown-menu-right shadow-sm animated--grow-in"
              aria-labelledby="userDropdown">
              <div class="dropdown-divider"></div>
              <span @click.prevent="setUser" class="cursor_pointer dropdown-item">
                <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                {{ getTranslations('expression_40') }}
              </span>
              <div class="dropdown-divider"></div>
              <span @click.prevent="logoutUser" class="dropdown-item cursor_pointer">
                <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                {{ getTranslations('expression_37') }}
              </span>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import Pagination from "./Pagination";
import NotificationsDropdown from "../general/NotificationsDropdown";
import logo_beecrm_white_blue from "../../assets/images/logo_beecrm_new_colors.png"
import flag_br from "../../assets/images/flags/br.svg"
import flag_es from "../../assets/images/flags/es.svg"
import flag_us from "../../assets/images/flags/us.svg"

export default {
  name: "Navbar",
  components: {
    NotificationsDropdown,
    Pagination
  },
  data() {
    return {
      logo_beecrm_white_blue: logo_beecrm_white_blue,
      flag_br: flag_br,
      flag_es: flag_es,
      flag_us: flag_us,
    }
  },
  computed: {
    ...mapState(['me', 'channels', 'configs', 'notifications', 'sources']),
    ...mapGetters([
      'getOperatorsArray',
    ]),

    showMyButton() {
      return ["testemeta.beelabs.com.br", "localhost.beelabs.com.br", "beelabs3.beelabs.localhost"].includes(
        window.location.hostname
      );
    },
  },
  methods: {
    ...mapActions(['logoutUser']),
    setUser() {
      window.localStorage.setItem("user_id", this.me.data.id)
      if (this.$route.name !== 'User') {
        this.$router.push({ name: "User" });
      }
    },
    showNotification(payload) {
      if (payload.status_key === 0) {
        this.$store.dispatch('updateNotification', {
          id: payload.id,
          status_key: 1
        })
        payload.status_key = 1
      }
      this.$store.commit('SET_NOTIFICATION', payload)
    },
    deleteAllNotifications() {
      this.$swal.fire({
        title: this.getTranslations('expression_310'),
        text: this.getTranslations('expression_311'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: this.getTranslations('expression_421'),
        cancelButtonText: this.getTranslations('expression_355')
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("deleteAllNotifications")
        }
      })
    },
    async setLanguage(lang) {
      const routeCurrent = this.$route.name;
      await this.$store.dispatch('updateUser', {
        id: this.me.data.id,
        channel_id: this.dashboard.channel_id,
        language_key: lang === 0 ? '0' : lang
      })
      await this.$store.dispatch('getReloadLang', { channel_id: this.dashboard.channel_id })
      if (this.$route.name !== 'Lead') {
        await this.$store.dispatch('getTickets', {
          status_key: [0, 1, 2, 3, 4, 5],
          channel_id: this.dashboard.channel_id,
          per_page: 10
        })
      }
      // Ignora erro de "Navegação duplicada" quando tenta acessar a mesma rota, mas exibe outros erros que possam ocorrer.
      await this.$router.push({ name: routeCurrent }).catch(error => {
        if (error.name !== "NavigationDuplicated") {
          throw error;
        }
      });
    }
  }
}
</script>

<style scoped>
.bg-primary-soft {
  background-color: #dae7fb !important;
}

.bg-secondary-soft {
  background-color: #d7d7d7 !important;
}

.bg-info-soft {
  background-color: #daf8fb !important;
}

.bg-warning-soft {
  background-color: #fbebda !important;
}

.bg-danger-soft {
  background-color: #fbdada !important;
}

.bg-success-soft {
  background-color: #dafbdb !important;
}

.text-primary {
  color: #0061f2 !important;
}

.logo_brand {
  height: 40px;
}

.logo {
  padding-right: 2rem;
}

.top_navbar {
  /*padding: 1.2rem 2rem;*/
  /*padding: 1rem 1.8rem;*/
  padding: .8rem 1.8rem;
}

.navigation {
  font-size: .8rem;
}

.middle {
  display: flex;
  justify-content: center;
}

.navbar-light .navbar-nav .nav-link {
  color: #aeaeae;
  /*font-weight: 300;*/
  font-family: "Product Sans Thin Regular";
  transition: color .2s;
}

.nav-link:hover {
  color: #38b5aa !important;
  transition: color .2s;
}

.navbar-light .navbar-nav .show>.nav-link,
.navbar-light .navbar-nav .active>.nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: #1f1f1f !important;
  /*color: #00baf6!important;*/
  transition: color .2s;
}

/*{*/
/*  min-width: 10rem;*/
/*  padding: 0.5rem 0;*/
/*  !*margin: 0.6rem 0 0;*!*/
/*  !*margin: 1rem 0 0;*!*/
/*  margin: 1rem 0 0;*/
/*  font-size: 0.85rem;*/
/*  color: #858796;*/
/*  background-color: #fff;*/
/*  border: 1px solid #e3e6f0;*/
/*  border-radius: 0;*/
/*}*/

.shadow {
  box-shadow: 0 0.15rem 1rem 0 rgba(58, 59, 69, 0.15) !important;
}
</style>
